<template>
  <div :style="{paddingTop: '10px'}">
    <a-empty :style="{paddingTop: '24px'}" v-if="chartData.length === 0" />
    <template v-if="!change && chartData.length > 0">
      <div class="uxexp-version-text" v-for="v in customVersions" :key="v.label" :style="{left: `${v.left}px`}">
        {{formatTime(v.label)}}
        <a-popover :title="formatTime(v.label)">
          <a-icon class="i-info" type="info-circle" />
          <template slot="content">
            <div class="custom-version-content" style="white-space: pre-line" v-if="remarkMap[v.label] && remarkMap[v.label].android_content">
              <span style="font-weight: bold">{{!isSimple ? 'Android:' : ''}} </span>{{remarkMap[v.label] ? remarkMap[v.label].android_content : undefined}}
            </div>
            <div class="custom-version-content" style="white-space: pre-line" v-if="!isSimple && remarkMap[v.label] && remarkMap[v.label].ios_content">
              <span style="font-weight: bold">iOS: </span>{{remarkMap[v.label] ? remarkMap[v.label].ios_content : undefined}}
            </div>
            <div class="custom-version-content" style="white-space: pre-line" v-if="!isSimple && remarkMap[v.label] && remarkMap[v.label].xgp_content">
              <span style="font-weight: bold">手柄版（XGP）: </span>{{remarkMap[v.label] ? remarkMap[v.label].xgp_content : undefined}}
            </div>
            <div :style="{textAlign: 'right', paddingTop: '12px'}"><a-button type="link" @click="handleEdit(v)">编辑</a-button></div>
          </template>
        </a-popover>
      </div>
    </template>
    <v-chart v-if="!change && chartData.length > 0" :forceFit="true" :height="400" :scale="chart.scale" :padding="[55, 35, 45, 45]">
      <v-tooltip :htmlContent="!this.selectedDate ? htmlContent : undefined" />
      <v-axis :dataKey="chart.xAxis.key" position="bottom" :label="chart.xAxis.label" :line="{lineWidth:1}" :tickLine="{length:5}" :title="chart.xAxis.title" />
      <v-axis :dataKey="chart.yAxis.key" position="left" :label="chart.yAxis.label" :line="{lineWidth:1}" :tickLine="{length:5}" :title="chart.yAxis.title" />
      <v-legend :allowAllCanceled="true" position="top-center" :offsetY="-20" />
      <v-view :data="chartData">
        <template v-if="!selectedDate">
          <v-series quickType="line" position="format_review_time*platform_rate" :color="chart.color" />
          <v-series :vStyle="{cursor: 'pointer'}" quickType="point" position="format_review_time*platform_rate" :color="chart.color" shape="circle" :size="5" :label="chart.label"
           :onClick="pointClick" />
        </template>
        <template v-if="selectedDate">
          <v-series quickType="bar" position="rate*count" :color="chart.color" :label="chart.label" :adjust="chart.adjust" />
        </template>
        <template>
          <v-guide v-for="{ id, type, content, start, end, position, lineStyle, style, offsetY, html } in guides" :key="id" :position="position"
            :type="type" :content="content" :start="start" :end="end" :v-style="style" :lineStyle="lineStyle" :top="true"
            :offsetY="offsetY" :html="html"
          />
        </template>
      </v-view>
    </v-chart>  
  </div>
</template>

<script>
import moment from "moment"
import Vue from 'vue';
import Viser from 'viser-vue';
import _ from 'lodash';
import { weekday } from '@/utils/utils'
import { MODE_ID_MAP } from '@/constants/fixed';

Vue.use(Viser);

const DEFAULT_CORRECT = 5;
const CHART_WIDTH = 1330 - 60;

export default {
  name: 'UxChart',
  props: ['data', 'remarkMap', 'selectedDate', 'selectedMode', 'isSimple'],
  data() {    
    return {
      change: false,
      htmlContent: function(title, items) {
        const titleDom = `<div class="g2-tooltip-title" style="margin-bottom: 4px;">测试日期 ${title}</div>`;
        
        const infoDoms = [];
        let tmpRemark = ``;
        items.forEach(item => {
          const tar = item.point._origin;
          infoDoms.push(
            `<li>${tar.platform || '-'} ${tar.mode_label}平均分: <span class="g2-tooltip-value">${(tar.platform_rate - DEFAULT_CORRECT).toFixed(1)}</span></li>` + 
            `<li>${tar.platform || '-'} 人数: <span class="g2-tooltip-value">${tar.count}</span></li>` + 
            `<li class="multi-wrap">${tar.platform || '-'} 备注: <span class="g2-tooltip-value">${tar.platform_remark}</span></li>`
          );
        });

        const info = `<ul class="g2-tooltip-list">${infoDoms.join('')}</ul>`;
        return `<div class="g2-tooltip">${titleDom}${info}</div>`;
      },
      customVersions: [],
    }
  },
  computed: {
    chart() {
      if (this.selectedDate) {
        const maxInfo = _.maxBy(this.chartData, 'count');
        return {
          scale: [{
            dataKey: 'rate',
            alias: "评分",
            type: 'cat'
          }, {
            dataKey: 'count',
            alias: "评分人数",
            min: 0,
            tickInterval: (maxInfo && maxInfo.count < 10) ? 1 : undefined,
          }],
          xAxis: {
            key: 'rate',
            title: {
              text: '评分',
              offset: 30,
            }
          },
          yAxis: {
            key: 'count',
            label: {
              autoRotate: false,
            },
            title: {
              text: '人数',
              offset: 30,
            }
          },
          label: [
            'count',
            {
              offset: 6,
              textStyle: {
                fontWeight: 'bold',
              },
              formatter: (v) => v > 0 ? v : undefined
            }
          ],
          color: this.isSimple ? ['#1890ff'] : ['platform', ['#1890ff', '#fdad28', '#16ab16']],
          adjust: [{
            type: 'dodge',
            marginRatio: 1 / 32,
          }]
        }
      } else {
        const xStep = this.chartData.length > 0 ? Math.ceil(_.uniq(this.chartData.map(c => c.review_time)).length / 36) : 1;
        return {
          scale: [{
            dataKey: 'format_review_time',
            alias: "日期",
            type: 'cat'
          }, {
            dataKey: 'platform_rate',
            alias: "版本平均分",
            min: 0,
            max: 10,
          }, {
            dataKey: 'platform',
            type: 'cat',
            values:this.selectedMode.id === MODE_ID_MAP.ALL?['Android', 'iOS', '手柄版（XGP）']: ['Android', 'iOS'],
          }],
          xAxis: {
            key: 'format_review_time',
            title: {
              text: '日期',
              offset: 30,
            },
            label: {
              autoRotate: false,
              // rotate: -30,
              // offset: 20,
              formatter: (val) => {
                return moment(val).format('MM-DD')
              },
              density: _.round(1 / xStep, 2),
            }
          },
          yAxis: {
            key: 'platform_rate',
            label: {
              autoRotate: false,
              formatter: (val) => {
                return val - DEFAULT_CORRECT;
              },
            },
            title: {
              text: '平均分',
              offset: 30,
            }
          },
          color: this.isSimple ? ['#1890ff'] : ['platform', ['#1890ff', '#fdad28', '#16ab16']]
          // label: [
          //   'platform_rate',
          //   (v) => _.round(v - DEFAULT_CORRECT, 1).toString()
          // ]
        }
      }
    },
    chartData() {
      let res = [];
      if (this.selectedDate) {
        Array.from({length: 11}).forEach((v, idx) => {
          (this.isSimple ? [null] :this.selectedMode.id === MODE_ID_MAP.ALL?['Android', 'iOS', '手柄版（XGP）']: ['Android', 'iOS']).forEach((p) => {
            res.push({
              rate: (idx - 5).toString(),
              count: 0,
              platform: p,
            })
          })
        });
        this.data.forEach(d => {
          if (this.selectedDate === d.review_time) {
            const existIdx = res.findIndex(v => v.rate.toString() === d.rate.toString() && d.platform === v.platform);
            if (existIdx !== -1) {
              res[existIdx].count += 1;
            }
          }
        });
      } else {
        this.data.forEach(d => {
          const exist = res.find(r => r.review_time === d.review_time && r.platform === d.platform);
          if (!exist) {
            res.push({
              review_time: d.review_time,
              avg_rate: d.avg_rate + DEFAULT_CORRECT,
              count: 1,
              format_review_time: this.formatTime(d.review_time),
              platform: this.isSimple ? null : d.platform,
              platform_rate: (this.isSimple ? d.avg_rate : d.platform_rate) + DEFAULT_CORRECT,
              platform_remark: (d.platform === 'iOS' ? this.remarkMap[d.review_time]?.ios_content : d.platform === '手柄版（XGP）' ? this.remarkMap[d.review_time]?.xgp_content :this.remarkMap[d.review_time]?.android_content) || '-',
              mode_label: this.selectedMode?.label || ''
            })
          } else {
            exist.count += 1;
          }
        });
      }

      this.change = true
      this.$nextTick(()=>{
        this.change = false
      });
      return res;
    },
    guides() {
      let res = [];
      // const len = (this.chartData || []).length;
      // const stepWidth = len > 0 ? _.divide(CHART_WIDTH, len) : 1;

      this.customVersions = [];
      if (this.selectedDate) {
        this.customVersions.push({
          label: this.selectedDate,
          left: _.round(CHART_WIDTH / 2 + 170)
        })
      } else {
        // this.chartData.map((v, idx) => {
        //   this.customVersions.push({
        //     label: v.review_version,
        //     left: _.round((idx + 0.5) * stepWidth)
        //   });
        // });

        // 日期横轴
        // if (this.chartData.length <= 150) {
        const tmpMap = {};
        this.chartData.forEach((cd) => {
          const wkDay = moment(cd.review_time).weekday();
          const isWeekend = wkDay > 4;
          if (!tmpMap[cd.format_review_time]) {
            const result = {
              id: `g_html_${cd.platform}_${cd.review_time}`,
              position: [cd.format_review_time, 0],
              type: "html",
              html: `<div class="chart_label_day ${isWeekend ? 'weekend' : '' }">${weekday[wkDay]}</div>`
            };
            tmpMap[cd.format_review_time] = result;
            res.push(result);
          }
        });
        if (Object.keys(tmpMap).length > 62) {
          res = [];
        }
        const sortedXList = Object.keys(tmpMap).sort((prev,next) => moment(prev).valueOf() - moment(next).valueOf());
        const stepWidth = sortedXList.length > 0 ? _.divide(CHART_WIDTH, sortedXList.length) : 1;
        // }
        // line zero
        res.push({
          id: `g_line_zero`,
          type: 'line',
          start: ['min', 'median'],
          end: ['max', 'median'],
          lineStyle: {
            stroke: '#b2b2b2',
            lineDash: [6, 3]
          }
        });
        // #region remark
        const extraRemarks = Object.entries(this.remarkMap || {}).filter(([rtime, val]) => {
          const f_time = sortedXList.length > 0 ? sortedXList.includes(this.formatTime(+rtime)) : true;
          return val.extra_content && f_time;
        }).sort((prev, next) => prev[0] - next[0]);
        const mtList = [];
        for (let i = 0; i < extraRemarks.length; i++) {
          const [rtime, val] = extraRemarks[i];
          res.push({
            type: 'line',
            start: [this.formatTime(+rtime), 'min'],
            end: [this.formatTime(+rtime), 'max'],
            lineStyle: {
              stroke:'#7190FF',
              strokeOpacity: 0.45
            }
          });
          const curIdx = sortedXList.findIndex(v => v === this.formatTime(+rtime));
          let newPush = true;
          let mtIdx = 0;
          for (let j = 0; j < mtList.length; j++) {
            const prevIdx = mtList[j][mtList[j].length - 1];
            if (curIdx && prevIdx && (curIdx - prevIdx) * stepWidth >= 80) {
              // 放得下
              mtList[j].push(curIdx);
              mtIdx = j;
              newPush = false;
              break;
            }
          }
          if (newPush) {
            mtList.push([curIdx])
            mtIdx = mtList.length - 1;
          }
          res.push({
            type: 'html',
            position: [this.formatTime(+rtime), 'max'],
            html: `<div class='uxexp_custom_marker mt-${mtIdx}' title='${val.extra_content}'><span>${val.extra_content}</span></div>`
          })
        }
        // #endregion
      }

      this.change = true
      this.$nextTick(()=>{
        this.change = false
      });
      return res;
    },
  },
  methods: {
    formatTime(t) {
      return moment(t).format('YYYY/MM/DD')
    },    
    pointClick(chart) {
      const { review_time } = chart.data._origin;
      this.$emit('changeSelectedDate', review_time);
    },
    handleEdit(v) {
      this.$emit('handleEditRemark', v);
    }
  }

}
</script>

<style lang="less">
.uxexp-version-text {
  position: absolute;
  z-index: 10;
  font-size: 18px;
  text-align: center;
  font-weight: bold;
  top: -8px;
  display: flex;
  align-items: center;
}
.i-info {
  padding-left: 4px;
}
.custom-version-content {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.uxexp_custom_marker {
  background:rgba(113, 144, 255, 0.5);
  border-radius: 5px;
  margin:-15px 0 0 0;
  font-size: 12px;
  color:#fff;
  // height:16px;
  // line-height: 16px;
  text-align: center;
  overflow: hidden;
  span {
    padding: 0 4px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &.mt-1 {
    margin-top: 12px;
  }
  &.mt-2 {
    margin-top: 40px;
  }
  &:after {
    position:absolute;
    bottom:0;
    left:50%;
    margin:0 0 -7px -5px;
    content:"";
    border-right:5px solid transparent;
    border-left:5px solid transparent;
    border-top:7px solid rgba(113, 144, 255, 0.5);
  }
}
</style>